/** Created by azhou on 2019/3/21.*/
<template>
    <div>
      <public-title>权限节点列表
        <el-button type="primary" size="small" class="ml-auto" slot="right" v-show="showpower"
                   @click="$router.push({name:'addAccessNode',query: {active:activeTab}})">添加权限节点</el-button>
      </public-title>
      <div class="bg-white p-5">
        <el-tabs v-model="activeTab" class="mb-4">
          <el-tab-pane :label="item.title" :name="item.value" :key="item.title" v-for="item in typeLists"/>
        </el-tabs>
        <el-tree :data="accessList" default-expand-all node-key="id" :expand-on-click-node="false" :props="defaultProps" />
      </div>
    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'AccessNode',
    computed: {
      ...mapState(['userLoginMessage']),
      ...mapGetters(['storeInfo'])
    },
    data() {
      return {
        accessList:[],
        typeLists:[
          {title:'管理员',value:'1'},
          {title:'采购商',value:'2'},
          {title:'酒店',value:'3'},
          {title:'导游',value:'4'},
          {title:'民宿',value:'5'},
          {title:'景区',value:'6'},
          {title:'品牌馆',value:'8'},
        ],
        activeTab:'1',
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        showpower: true
      }
    },
    watch:{
      'activeTab':'getAccessList'
    },
    created() { 
      if(this.$route.query.tab)this.activeTab=this.$route.query.tab;
      this.userLoginMessage.power_id_arr.includes(450) ? this.showpower = true : this.showpower = false
      this.getAccessList();
    },
    methods: {
      /*获取权限值列表*/
      async getAccessList() {
        let res = await this.$axios.post('/pc/Admin/GetPositionPowerTree',{
          is_admin:this.activeTab
        });
        if (res.code === '00000' || res.code === '99999') { this.accessList = res.info || [] }
      }
    }
  }
</script>
